import { GetterTree } from 'vuex'
import * as types from './types';

export default <GetterTree<board.state.BoardState, RootState>>{
    [types.BOARD_ARTICLE_CURRENT](state: board.state.BoardState) {
        return state.currentArticle
    }
}
